/**
 * Capacitor native bridge — entry.
 *
 * 모든 Capacitor API 호출은 본 폴더의 wrapper 경유. 웹 환경에서는 no-op.
 * 각 wrapper:
 *   - lazy import (web 빌드 시 트리쉐이킹)
 *   - try/catch 래핑 (plugin import / 호출 실패해도 앱 죽지 않음)
 *   - isNative() 가드
 */

import { Capacitor } from "@capacitor/core";

/** 현재 native 환경인지 (Android / iOS WebView 안에서 실행 중) */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

/** 현재 platform 식별자 ('web' | 'android' | 'ios') */
export function getPlatform(): "web" | "android" | "ios" {
  return Capacitor.getPlatform() as "web" | "android" | "ios";
}

/** 디버그 출력. prod 에서도 남긴다(경고 레벨) — 온디바이스 이슈를 chrome://inspect 로 추적하기 위함. */
export function nativeWarn(scope: string, err: unknown): void {
  // eslint-disable-next-line no-console
  console.warn(`[native:${scope}]`, err);
}

// 편의 export
export * from "./haptics";
export * from "./statusBar";
export * from "./network";
export * from "./splashControl";
export * from "./sessionContinuity";
export * from "./share";
export * from "./keyboard";
export * from "./app";
export * from "./safeArea";
export * from "./insets";
